import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CercadorEsplaisComponent } from './cercador-esplais.component';
import { NbThemeModule, NbCardModule, NbInputModule, NbButtonModule, NbSelectModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { LogoRenderComponent } from '../logo-render/logo-render.component';

@NgModule({
  declarations: [CercadorEsplaisComponent, LogoRenderComponent],
  imports: [
    CommonModule,
    NbThemeModule,
    NbCardModule,
    NbInputModule,
    Ng2SmartTableModule,
    NbButtonModule,
    NbSelectModule,
    FormsModule,
    NbSpinnerModule,
  ],
  entryComponents: [
    LogoRenderComponent,
  ]
})
export class CercadorEsplaisModule { }
